import React from 'react';
import {useTranslation} from 'react-i18next';
import LoadingLayout from './LoadingLayout.tsx';

type Props = {};

export default function LoadingDashboard({}: Props) {
    const {t} = useTranslation();
    return (
        <LoadingLayout>
            {t('admin:loading_dashboard', 'Loading Dashboard…')}
        </LoadingLayout>
    );
}
